export default "__VITE_ASSET__d3bYiIMT__"